var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import TabsStateless from './tabs-stateless';
var Tabs = (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedTab: _this.props.textArray[0],
            textArray: _this.props.textArray,
        };
        return _this;
    }
    Tabs.prototype.handleClickTabItem = function (t) {
        var onClickTab = this.props.onClickTab;
        this.setState({
            selectedTab: t,
        });
        if (typeof onClickTab === 'function') {
            onClickTab(t);
        }
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        return (React.createElement(TabsStateless, { className: className || '', selectedTab: this.state.selectedTab, textArray: this.state.textArray, onClickTab: function (t) { return _this.handleClickTabItem(t); } }));
    };
    return Tabs;
}(React.Component));
export default Tabs;
//# sourceMappingURL=tabs.js.map